import { createPortal } from 'react-dom';
import { useProject } from '@contexts/Project.context';
import SidebarTemplate from '@routes/userRoutes/projects/singleProject/components/sidebars/sidebarElements/SidebarTemplate';

/**
 * Custom hook for rendering layer settings in a portal
 * Abstracts the common pattern of creating settings sidebars for map layers
 *
 * @param {string} sidebarId - Unique identifier for the sidebar
 * @param {string} header - Header text for the sidebar
 * @param {React.ReactNode} children - Content to render in the sidebar
 * @param {Object} options - Additional options
 * @param {number} options.zIndex - Z-index for the sidebar
 * @param {boolean} options.closeable - Whether the sidebar can be closed
 * @returns {React.ReactNode|null} Portal element or null if ref not available
 */
export const useLayerSettingsPortal = (sidebarId, header, children, options = {}) => {
	const { modifyLayersSidebarRef } = useProject();
	const { zIndex = 2, closeable = true } = options;

	if (!modifyLayersSidebarRef?.current) {
		return null;
	}

	return createPortal(
		<SidebarTemplate
			sidebarId={sidebarId}
			zindex={zIndex}
			header={header}
			closeable={closeable}>
			{children}
		</SidebarTemplate>,
		modifyLayersSidebarRef.current
	);
};
